import { Link } from "react-scroll";
import { useState } from "react";
import logo from "../../_assets/images/logo.png";
import logo_b from "../../_assets/images/logo_b.png";
import QAMainComponent from "./QAMainComponent";
import birthday_btn from "../../_assets/images/birthday_btn.jpg";
import weekend_btn from "../../_assets/images/weekend_btn.jpg";
import MorningComponent from "./MorningComponent";
import BirthDayComponent from "./BirthDayComponent";
import { ContentComponent } from "../ComponentCss";
import WeekendComponent from "./WeekendComponent";
import { ShareComponent } from "../CommonComponent";
import FooterComponent from "../FooterComponent";

const QAComponent = () => {
    const [spyEle, setSpyEle] = useState('');
    const [bgIsBlack, setBgIsBlack] = useState(true);
    const [supportVisible, setSupportVisible] = useState(true);

    return (    
      <ContentComponent bgIsBlack={ bgIsBlack } spyEle={ spyEle } supportVisible={ supportVisible }>
        <article id="main">
          <QAMainComponent />
        </article>        
        <article id="morning">
          <MorningComponent playState={ spyEle } setBgIsBlack={ setBgIsBlack } setSupportVisible={ setSupportVisible } />
        </article>    
        <article id="birthday">
          <BirthDayComponent playState={ spyEle } setBgIsBlack={ setBgIsBlack } setSupportVisible={ setSupportVisible } />
        </article>   
        <article id="weekend">
          <WeekendComponent playState={ spyEle } setSpyEle={ setSpyEle } setBgIsBlack={ setBgIsBlack } setSupportVisible={ setSupportVisible } />
        </article> 
        <ShareComponent />
        <FooterComponent setSpyEle={ setSpyEle } />
        <button className="support-cont pc" onClick={ () => window.open("https://www.unicef.or.kr/donate/?supportTerm=FM01&supportCategory=D001&solicitcode=DR22E") } alt="후원하기 버튼">
          <img src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/support_btn.5f0c666ffee388070630.png" } alt="후원하기 버튼 이미지" style={{ width: "15rem" }} />
        </button>
        <button className="support-cont2 mo" onClick={ () => window.open("https://www.unicef.or.kr/donate/?supportTerm=FM01&supportCategory=D001&solicitcode=DR22E") } alt="후원하기 버튼">
          <img src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/support_btn2.e3baf47c8ce00f5976aa.png" } alt="후원하기 버튼 이미지" />  
        </button>
        <div className="btn-cont2">
            <Link to="morning" className="js-war" spy={ true } onSetActive={ el => setSpyEle(el) } onSetInactive={ () => setSpyEle('') } onClick={ () => setSpyEle('morning') }>
              <img src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/morning_btn.2e21871c3d421fa9fadd.jpg" } alt="11살 아이의 아침 이야기 버튼" className="pc" />
              11살 아이의 아침 이야기
            </Link>
            <Link to="birthday" className="js-marr" spy={ true } onSetActive={ el => setSpyEle(el) } onClick={ () => setSpyEle('birthday') }>
              <img src={ birthday_btn } alt="11살 아이의 생일 이야기 버튼" className="pc" />
              11살 아이의 생일 이야기
            </Link>
            <Link to="weekend" className="js-marr" spy={ true } onSetActive={ el => setSpyEle(el) } onClick={ () => setSpyEle('weekend') }>
              <img src={ weekend_btn } alt="11살 아이의 주말 이야기 버튼" className="pc" />
              11살 아이의 주말 이야기
            </Link>
        </div>
        <img src={ spyEle === "" ? logo : logo_b } alt="유니세프 로고" className="logo pc" />
      </ContentComponent>
    );
}

export default QAComponent;
